import React from 'react';
import AnswerChecker from '../AnswerChecker';

export default function PlotGame(props:any) {
  const {onNextGame}=props;

  return <>
  <pre>A1 B13 E6 A9 C1 B16 D12 A2 C13 A6 A18 B6 B17
     C11 D9 E1 E18 A13 E13 B1 B9 D17 E16 D6 C9 B10 E9 A16 B3 C2 D1 C6 D13 C16 D16</pre>
     <br/>
     <AnswerChecker onNextGame={onNextGame} correctAnswer="da650c43bb71d12303a8c7d8d293d40dfaa7e51cf3ef48428b58cd2cd02e739c"/>
      </>
}
